<template>
    <div>
        <div v-if="!sended.message" id="reset-password-form">
            <b-field :label="__('strings.auth.labels.email')"
                     label-position="on-border"
                     :type="{'is-danger': errors.email}"
                     :message="errors.email">
                <b-input :placeholder="__('strings.auth.labels.email')"
                         type="email" name="email"
                         icon="account" v-model="input.email" @focus="clearError">
                </b-input>
            </b-field>

            <b-field :label="__('strings.auth.reset.password')"
                     label-position="on-border"
                     :type="{'is-danger': errors.password}"
                     :message="errors.password">
                <b-input :placeholder="__('strings.auth.reset.password')"
                         type="password" name="password"
                         icon="key" v-model="input.password" @focus="clearError">
                </b-input>
            </b-field>

            <b-field :label="__('strings.auth.reset.password-confirm')"
                     label-position="on-border">
                <b-input :placeholder="__('strings.auth.reset.password-confirm')"
                         type="password" name="password_confirmation"
                         icon="key" v-model="input.password_confirmation" @focus="clearError">
                </b-input>
            </b-field>

            <div class="field">
                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          :label="__('strings.auth.reset.button')"
                          @click.prevent="reset"
                          rounded
                          outlined
                          expanded></b-button>
            </div>
        </div>
        <b-message v-else type="is-success" has-icon>
            <p v-text="sended.message" class="mb-2"></p>
            <router-link :to="{name: 'auth.login'}">Return to login</router-link>
        </b-message>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                input: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                    token: ''
                },
                errors: {
                    email: '',
                    password: ''
                },
                sended: {
                    message: ''
                }
            }
        },
        mounted() {
            this.input.token = this.$route.params.token
        },
        methods: {
            reset() {
                axios.post('/update-password', this.input)
                    .then(response => {
                        this.sended.message = response.data.message
                    })
                    .catch(error => {
                        this.input.password_confirmation = ''
                        this.input.password = ''
                        this.errors = error.response.data.errors
                    })
            },
            clearError(event) {
                this.errors[event.target.name] = '';
            }
        }
    }
</script>